export default __webpack_public_path__ + "static/media/icon_sidebar_expandAll.35b053c1.svg";